import { render, staticRenderFns } from "./BaseButtonLanding.vue?vue&type=template&id=35308198&scoped=true"
import script from "./BaseButtonLanding.vue?vue&type=script&lang=ts"
export * from "./BaseButtonLanding.vue?vue&type=script&lang=ts"
import style0 from "./BaseButtonLanding.vue?vue&type=style&index=0&id=35308198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35308198",
  null
  
)

export default component.exports